<lib-dialog-layout [showActions]="true" [alignActions]="'center'">
  <ng-container content>
    <div class="pb3 pt2">
      <lib-simple-dialog-content
        [mainText]="data.mainText"
        [subText]="data.subText"
        [image]="data.image"
        [themedImage]="data.themedImage"
      ></lib-simple-dialog-content>
    </div>
  </ng-container>

  <ng-container actions>
    <div class="app-fork-dialog-actions flex justify-center mb3">
      <lib-button
        *ngFor="let action of data.actions; let i = index"
        class="app-fork-dialog-button"
        [class.app-fork-dialog-button--first]="i === 0"
        [class.app-fork-dialog-button--last]="i === data.actions.length - 1"
        [weight]="action.weight"
        (click)="action.callback()"
        (click)="closeDialog()"
        >{{ action.title }}</lib-button
      >
    </div>
  </ng-container>
</lib-dialog-layout>
